import { c as _c } from "react/compiler-runtime";
import { colors } from '@newfront-insurance/core-ui';
import { Button, cn } from '@newfront-insurance/core-ui/v2';
import type { FileAttachment } from '@newfront-insurance/nova-core';
import { ArrowUpIcon, Loader2 } from 'lucide-react';
import { useChatInputContext } from './chat-input-context';
import { useChatOverlayContext } from '../../contexts/chat-overlay-context';
interface SendButtonProps {
  className?: string;
}

/**
 * Send button component for chat input.
 * Uses context to access input state and submit handler.
 * Shows loading state when chat is submitting/streaming.
 */
export function SendButton(t0) {
  const $ = _c(26);
  const {
    className
  } = t0;
  const {
    input,
    handleSubmit,
    status
  } = useChatInputContext();
  const {
    additionalContext
  } = useChatOverlayContext();
  let t1;
  if ($[0] !== additionalContext?.attachments) {
    t1 = additionalContext?.attachments as FileAttachment[] ?? [];
    $[0] = additionalContext?.attachments;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const attachments = t1;
  let T0;
  let isDisabled;
  let t2;
  let t3;
  let t4;
  if ($[2] !== attachments || $[3] !== className || $[4] !== input.length || $[5] !== status) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const hasUploadingFiles = attachments.some(_temp);
      isDisabled = input.length === 0 && attachments.length === 0 || hasUploadingFiles;
      if (["submitted", "streaming"].includes(status)) {
        let t5;
        if ($[11] !== className) {
          t5 = cn("bg-lime-blue-gradient h-fit rounded-full border-none bg-clip-padding p-2", "text-brand-500 hover:opacity-90", className);
          $[11] = className;
          $[12] = t5;
        } else {
          t5 = $[12];
        }
        let t6;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <Loader2 size={14} className="animate-spin" />;
          $[13] = t6;
        } else {
          t6 = $[13];
        }
        let t7;
        if ($[14] !== t5) {
          t7 = <Button data-testid="loading-button" className={t5} disabled={true}>{t6}</Button>;
          $[14] = t5;
          $[15] = t7;
        } else {
          t7 = $[15];
        }
        t4 = t7;
        break bb0;
      }
      T0 = Button;
      t2 = "send-button";
      t3 = cn("bg-lime-blue-gradient h-fit rounded-full border-none bg-clip-padding p-2", "hover:opacity-90", "border-transparent", className, {
        "cursor-not-allowed bg-[#e5e7eb] opacity-50": isDisabled
      });
    }
    $[2] = attachments;
    $[3] = className;
    $[4] = input.length;
    $[5] = status;
    $[6] = T0;
    $[7] = isDisabled;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    T0 = $[6];
    isDisabled = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[16] !== handleSubmit || $[17] !== isDisabled) {
    t5 = event => {
      event.preventDefault();
      if (!isDisabled) {
        handleSubmit(undefined);
      }
    };
    $[16] = handleSubmit;
    $[17] = isDisabled;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ArrowUpIcon size={14} color={colors.brand[500]} />;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== T0 || $[21] !== isDisabled || $[22] !== t2 || $[23] !== t3 || $[24] !== t5) {
    t7 = <T0 data-testid={t2} className={t3} onClick={t5} disabled={isDisabled}>{t6}</T0>;
    $[20] = T0;
    $[21] = isDisabled;
    $[22] = t2;
    $[23] = t3;
    $[24] = t5;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
}
function _temp(attachment) {
  return attachment.isUploading;
}